import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";

const getFinancialYearOptions = () => {
  const currentYear = new Date().getFullYear();

  const years = [];
  for (let i = -2; i <= 2; i++) {
    const start = currentYear + i;
    const end = start + 1;
    years.push({
      label: `${start}-${end.toString().slice(-2)}`,
      value: `${start}-${end.toString().slice(-2)}`,
    });
  }

  return years;
};

export const COLUMNS_DATA = ({
  deleteRow,
  editBranch,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  filters,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Employee Code",
    accessor: "employee_code_id",
    disableSortBy: true,
  },
  {
    Header: "Employee Name",
    accessor: "employee_name",
    disableSortBy: true,
  },
  {
    Header: "Target",
    accessor: "target",
    disableSortBy: true,
  },
  {
    Header: "Target Type",
    accessor: "target_type",
    disableSortBy: true,
  },
  {
    Header: "Financial Year",
    accessor: "financial_year",
    disableSortBy: true,
  },
  {
    Header: "Created By",
    accessor: "created_by_name",
    disableSortBy: true,
  },
  {
    Header: "",
    accessor: "id",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More...
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => editBranch(cell.row.original)}
              >
                Edit
              </button>
            </li>

            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRow(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}
            <li>
              <button className="dropdown-item">Something else here</button>
            </li>
          </ul>
        </>
      );
    },
  },
];

export const FORM_CONFIG = (rowData) => [
  {
    label: "Employee",
    type: "select",
    name: "employee_name",
    defaultValue: rowData?.employee_code_id || "",
    validations: {
      required: true,
    },
    zoneId: true,
  },
  {
    label: "Target",
    type: "input-number",
    name: "target",
    defaultValue: rowData?.target || "",
    validations: {
      required: true,
      min: 0,
    },
  },
  {
    label: "Target Type",
    type: "select",
    name: "target_type",
    defaultValue: rowData?.target_type || "MONTHLY",
    options: [
      { label: "Monthly", value: "MONTHLY" },
      { label: "Quarterly", value: "QUARTERLY" },
      { label: "Yearly", value: "YEARLY" },
    ],
    validations: {
      required: true,
    },
  },
  {
    label: "Financial Year",
    type: "select",
    name: "financial_year",
    defaultValue:
      rowData?.financial_year ||
      `${new Date().getFullYear()}-${(new Date().getFullYear() + 1)
        .toString()
        .slice(-2)}`,
    options: getFinancialYearOptions(),
    validations: {
      required: true,
    },
  },
];

export const OPTIONS = [
  { key: "branch", value: "Branch" },
  { key: "state", value: "State" },
  { key: "city", value: "City" },
  { key: "area_name", value: "Area Name" },
  { key: "branch_address", value: "Address" },
  { key: "zone_name", value: "Zone" },
];
export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];
export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
